import React, { useState } from 'react';
import {
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Center,
  Tr,
  useColorModeValue,
  Button,
} from '@chakra-ui/react';
import moment from 'moment';
import { OrderStatusOptions, OrderTypeOptions } from 'config/constant';
import Card from 'components/card/Card';

const OrderItemTable = (props) => {
  const orderItemList = props.orderItems;
  const orderData = props.orderData;

  const textColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const currentOrderType = orderData?.order_type;

  const renderOrderDetails = () => {
    switch (currentOrderType) {
      case 'OPEN_SAVING_PLAN':
      case 'INSTALLMENT_SAVING_PLAN':
        return (
          <Flex direction='column' gap={2}>
            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                {orderData?.orderitem[0]?.details?.category_code} Number
              </Text>
              <Text>
                {orderData?.orderitem[0]?.details?.account_number}
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Plan Maturity Date
              </Text>
              <Text>
                {moment(orderData?.orderitem[0]?.details?.end_date).format('DD MMM YYYY')}
              </Text>
            </Flex>


            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Installment Number
              </Text>
              <Text>
                {orderData?.orderitem[0]?.details?.installment_no}
              </Text>
            </Flex>

            {
              orderData?.orderitem[0]?.details?.metal_price && (
                <Flex justifyContent='space-between' gap={2}>
                  <Text fontWeight='medium'>
                    Buy Gold Rate
                  </Text>
                  <Text>
                    Rs {orderData?.orderitem[0]?.details?.metal_price} / gm
                  </Text>
                </Flex>
              )
            }

            {
              orderData?.orderitem[0]?.details?.weight_credit && (
                <Flex justifyContent='space-between' gap={2}>
                  <Text fontWeight='medium'>
                    Gold Weight
                  </Text>
                  <Text>
                    {orderData?.orderitem[0]?.details?.weight_credit} gms 22KT
                  </Text>
                </Flex>
              )
            }

          </Flex>
        );
      case 'CLOSE_SAVING_PLAN':
        return (
          <Flex direction='column' gap={2}>
            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                {orderData?.orderitem[0]?.details?.category_code} Number
              </Text>
              <Text>
                {orderData?.orderitem[0]?.details?.account_number} ({orderData?.orderitem[0]?.details?.total_month})
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Amount Recived ( in Saving Plan )
              </Text>
              <Text>
                Rs {orderData?.details?.customer_saving_plan_details?.total_deposited_amount}
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Total Gold Weight
              </Text>
              <Text>
                {orderData?.details?.customer_saving_plan_details?.total_gold_weight} gms 22KT
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Plan Maturity Date
              </Text>
              <Text>
                {moment(orderData?.details?.customer_saving_plan_details?.end_date).format('DD MMM YYYY')}
              </Text>
            </Flex>
          </Flex>
        );
      case 'INSTALLMENT_SAVING_PLAN':
        return (
          <Flex direction='column' gap={2}>
            <Text>This is an Installment order.</Text>
          </Flex>
        );
      case 'BUY_LOCKER':
        const baseAmount = Number(orderData?.orderitem[0]?.details?.base_amount) || 0;
        const advanceBook = Number(orderData?.details?.advance_book) || 0;
        const result = (baseAmount * advanceBook) / 100;
        const formattedResult = Number.isInteger(result)
          ? result
          : result.toFixed(2).replace(/\.?0+$/, '');

        const goldWeightRaw = orderData?.details?.gold_weight;
        const goldWeight = Number(goldWeightRaw) || 0;

        const formattedGoldWeight = goldWeight % 1 === 0
          ? goldWeight
          : goldWeight.toFixed(3)

        const balanceAmount = baseAmount - result;
        const formattedBalanceAmount = Number.isInteger(balanceAmount)
          ? balanceAmount
          : balanceAmount.toFixed(2).replace(/\.?0+$/, '');

        return (
          <Flex direction='column' gap={2}>
            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Gold Booked Amount
              </Text>
              <Text>
                Rs {formattedResult} ({advanceBook})
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Buy Gold Rate
              </Text>
              <Text>
                Rs {orderData?.details?.gold_buy_price} / gm
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Gold Weight
              </Text>
              <Text>
                {formattedGoldWeight} gms 22KT
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Balance Advance Amount
              </Text>
              <Text>
                Rs {formattedBalanceAmount}
              </Text>
            </Flex>

          </Flex>
        );
      case 'SELL_LOCKER':
        const baseAmountSell = Number(orderData?.orderitem[0]?.details?.base_amount) || 0;
        const extraAmountSell = Number(orderData?.orderitem[0]?.details?.extra_amount) || 0;
        const totalAmountSell = Number((baseAmountSell - extraAmountSell).toFixed(2));
        const gst = baseAmountSell - Number(orderData?.orderitem[0]?.amount);
        const gstAmount = Number(gst) || 0;
        const formattedGstAmount = Number.isInteger(gstAmount)
          ? gstAmount
          : gstAmount.toFixed(2).replace(/\.?0+$/, '');

        const goldWeightSellRaw = orderData?.details?.gold_weight;
        const goldWeightSell = Number(goldWeightSellRaw) || 0;

        const formattedGoldSellWeight = goldWeightSell % 1 === 0
          ? goldWeightSell
          : goldWeightSell.toFixed(3)

        return (
          <Flex direction='column' gap={2}>
            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Sell Gold Rate
              </Text>
              <Text>
                Rs {orderData?.details?.gold_sell_price} / gm
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Gold Weight
              </Text>
              <Text>
                {formattedGoldSellWeight} gms 22KT
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Gold Amount
              </Text>
              <Text>
                Rs {totalAmountSell}
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Balance Advance Amount
              </Text>
              <Text>
                Rs {extraAmountSell}
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                GST
              </Text>
              <Text>
                Rs {formattedGstAmount}
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Total Transfer Amount
              </Text>
              <Text>
                Rs {orderData?.orderitem[0]?.amount}
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Registered Bank Account
              </Text>
              <Text>
                {orderData?.details?.bank_details?.account_number}
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                IFSC code
              </Text>
              <Text>
                {orderData?.details?.bank_details?.ifsc}
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Account Holder Name
              </Text>
              <Text>
                {orderData?.details?.bank_details?.holder_name}
              </Text>
            </Flex>

          </Flex>
        );
      case 'WITHDRAWAL_MONEY_SAVING_PLAN':
        return (
          <Flex direction='column' gap={2}>
            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                {orderData?.orderitem[0]?.details?.category_code} Number
              </Text>
              <Text>
                {orderData?.orderitem[0]?.details?.account_number}
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Amount Recived ( in Saving Plan )
              </Text>
              <Text>
                Rs {orderData?.details?.customer_saving_plan_details?.total_deposited_amount}
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Plan Maturity Date
              </Text>
              <Text>
                {moment(orderData?.orderitem[0]?.details?.end_date).format('DD MMM YYYY')}
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Registered Bank Account
              </Text>
              <Text>
                {orderData?.details?.bank_details?.account_number}
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                IFSC code
              </Text>
              <Text>
                {orderData?.details?.bank_details?.ifsc}
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Account Holder Name
              </Text>
              <Text>
                {orderData?.details?.bank_details?.holder_name}
              </Text>
            </Flex>

          </Flex>
        );
      case 'SELL_GOLD_SAVING_PLAN':
        return (
          <Flex direction='column' gap={2}>
            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                {orderData?.orderitem[0]?.details?.category_code} Number
              </Text>
              <Text>
                {orderData?.orderitem[0]?.details?.account_number}
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Amount Recived ( in Saving Plan )
              </Text>
              <Text>
                Rs {orderData?.details?.customer_saving_plan_details?.total_deposited_amount}
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Total Gold Weight
              </Text>
              <Text>
                {orderData?.details?.total_gold_weight} gms 22KT
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Plan Maturity Date
              </Text>
              <Text>
                {moment(orderData?.orderitem[0]?.details?.end_date).format('DD MMM YYYY')}
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Registered Bank Account
              </Text>
              <Text>
                {orderData?.details?.bank_details?.account_number}
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                IFSC code
              </Text>
              <Text>
                {orderData?.details?.bank_details?.ifsc}
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Account Holder Name
              </Text>
              <Text>
                {orderData?.details?.bank_details?.holder_name}
              </Text>
            </Flex>

          </Flex>
        );
      case 'LOCKER_JEWELLERY_REDEEM':
        return (
          <Flex direction='column' gap={2}>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Average Buy Gold Rate
              </Text>
              <Text>
                Rs {orderData?.orderitem[0]?.details?.average_buy_price} / gm
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Total Requested Gold Weight
              </Text>
              <Text>
                {orderData?.orderitem[0]?.details?.weight_debit} gms 22KT
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Balance Advance Amount
              </Text>
              <Text>
                Rs {orderData?.orderitem[0]?.details?.extra_amount}
              </Text>
            </Flex>
          </Flex>
        );
      default:
        return (
          <Flex direction='column' gap={2}>
            <Text>No specific content for this order type.</Text>
          </Flex>
        );
    }
  };

  const renderCompanyDetails = () => {
    switch (currentOrderType) {
      case 'OPEN_SAVING_PLAN':
      case 'INSTALLMENT_SAVING_PLAN':
      case 'WITHDRAWAL_MONEY_SAVING_PLAN':
      case 'SELL_GOLD_SAVING_PLAN':
      case 'LOCKER_JEWELLERY_REDEEM':
        return (
          <Flex direction='column' gap={2}>
            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Branch
              </Text>
              <Text>
                {orderData?.details?.company_details?.store_name} ({orderData?.details?.company_details?.store_code})
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Company
              </Text>
              <Text>
                {orderData?.details?.company_details?.company_name}
              </Text>
            </Flex>
          </Flex>
        );
      case 'CLOSE_SAVING_PLAN':
        return (
          <Flex direction='column' gap={2}>
            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Redemption Branch
              </Text>
              <Text>
                {orderData?.details?.company_details?.store_name} ({orderData?.details?.company_details?.store_code})
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Redemption Company
              </Text>
              <Text>
                {orderData?.details?.company_details?.company_name}
              </Text>
            </Flex>
          </Flex>
        );
      case 'BUY_LOCKER':
      case 'SELL_LOCKER':
        return (
          <Flex direction='column' gap={2}>
            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Branch
              </Text>
              <Text>
                {orderData?.details?.company_details?.store_name} ({orderData?.details?.company_details?.store_code})
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Company
              </Text>
              <Text>
                {orderData?.details?.company_details?.company_name}
              </Text>
            </Flex>

            <Flex justifyContent='space-between' gap={2}>
              <Text fontWeight='medium'>
                Operation Location
              </Text>
              <Text>
                {orderData?.details?.company_details?.operation_location_name}
              </Text>
            </Flex>

          </Flex>
        );
      default:
        return (
          <Flex direction='column' gap={2}>
            <Text>No specific content for this order type.</Text>
          </Flex>
        );
    }
  };

  return (
    <Flex direction={{ base: 'column', md: 'row' }} gap={4}>
      <Card display='flex' gap={4} >
        <Text fontSize='lg' fontWeight='medium' textAlign='center'>
          Order Details
        </Text>
        {/* Additional order details */}
        {renderOrderDetails()}
      </Card>
      <Card display='flex' gap={4}>
        <Text fontSize='lg' fontWeight='medium' textAlign='center'>
          Branch Details
        </Text>
        {renderCompanyDetails()}
      </Card>
    </Flex>
  )
};

export default OrderItemTable;
